export default __webpack_public_path__ + "static/media/03.710f64a9.jpg";